import { Box, customStyled, Flex } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';
import { StyledDrawerTitle } from 'common/styled/Drawer.style';
import COLORS from 'theme/colors';

export const ApplyButton = customStyled(RoundCornerButton)(({ theme: { fonts } }) => ({
  fontFamily: fonts.montserrat,
}));

export const AppliedPromoDescription = customStyled(Box)(({ theme: { colors, fontSizes } }) => ({
  fontSize: fontSizes[2],
  color: COLORS.GRAY_SCALE,
  textAlign: 'center',
}));

export const ButtonRow = customStyled(Flex)(({ theme }) => ({
  marginBottom: theme.space[3],
}));

export const CancelButton = customStyled(ApplyButton)(({ theme: { colors } }) => ({
  color: colors.blue,
  marginRight: 2,
}));

export const DrawerTitle = customStyled(StyledDrawerTitle)(({ theme: { fonts } }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ErrorMessage = customStyled(Flex)(props => ({
  fontSize: props.theme.fontSizes[1],
  color: props.theme.colors.red100,
  padding: `${props.theme.space[2]}px 0`,
  alignItems: 'center',
}));

export const HintIconWrapper = customStyled(Box)(({ theme }) => ({
  marginRight: theme.space[1],
  height: '20px',
}));

export const PromoCodeDrawer = customStyled(Flex)(({ theme: { fonts, space } }) => ({
  flexDirection: 'column',
  height: 'calc(100% - 100px)',
  fontFamily: fonts.montserrat,
  marginBottom: space[4],
}));

export const PromoIconWrapper = customStyled(Box)(({ theme }) => ({
  marginRight: theme.space[1],
  height: '24px',
}));
